module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2",
    attrs: {
      "id": "conte"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_vii"
    }
  }), _c('strong', [_vm._v("Contents")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/abbreviation#abb"
    }
  }, [_c('em', [_vm._v("List of Abbreviations")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/introduction#int"
    }
  }, [_vm._v("Introduction: The Prescription in Perspective"), _c('br'), _c('em', [_vm._v("Jeremy A. Greene and Elizabeth Siegel Watkins")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap1"
  }, [_c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/chapter1#ch1"
    }
  }, [_vm._v("1    Goofball Panic: Barbiturates, “Dangerous” and Addictive"), _c('br'), _vm._v("Drugs, and the Regulation of Medicine in Postwar America"), _c('br'), _c('em', [_vm._v("Nicolas Rasmussen")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap1"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/chapter2#ch2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2    Pharmacological Restraints: Antibiotic Prescribing and the"), _c('br'), _vm._v("Limits of Physician Autonomy"), _c('br'), _c('em', [_vm._v("Scott H. Podolsky")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap1"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/chapter3#ch3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3    “Eroding the Physician’s Control of Therapy”: The Postwar"), _c('br'), _vm._v("Politics of the Prescription"), _c('br'), _c('em', [_vm._v("Dominique A. Tobbell")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap1"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/chapter4#ch4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4    Deciphering the Prescription: Pharmacists and the Patient"), _c('br'), _vm._v("Package Insert"), _c('br'), _c('em', [_vm._v("Elizabeth Siegel Watkins")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap1"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/chapter5#ch5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5    The Right to Write: Prescription and Nurse Practitioners"), _c('br'), _c('em', [_vm._v("Julie A. Fairman")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap1"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/chapter6#ch6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6    The Best Prescription for Women’s Health: Feminist"), _c('br'), _vm._v("Approaches to Well-Woman Care"), _c('br'), _c('em', [_vm._v("Judith A. Houck")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap1"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/chapter7#ch7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7    “Safer Than Aspirin”: The Campaign for Over-the-Counter"), _c('br'), _vm._v("Oral Contraceptives and Emergency Contraceptive Pills"), _c('br'), _c('em', [_vm._v("Heather Munro Prescott")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap1"
  }, [_c('a', {
    attrs: {
      "id": "page_viii"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/chapter8#ch8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8    The Prescription as Stigma: Opioid Pain Relievers and the"), _c('br'), _vm._v("Long Walk to the Pharmacy Counter"), _c('br'), _c('em', [_vm._v("Marcia L. Meldrum")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap1"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/chapter9#ch9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9    Busted for Blockbusters: “Scrip Mills,” Quaalude, and"), _c('br'), _vm._v("Prescribing Power in the 1970s"), _c('br'), _c('em', [_vm._v("David Herzberg")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap1"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/chapter10#ch10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10   The Afterlife of the Prescription: The Sciences of"), _c('br'), _vm._v("Therapeutic Surveillance"), _c('br'), _c('em', [_vm._v("Jeremy A. Greene")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapa"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/back#bac",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Time Line of Federal Regulations and Rulings Related to the Prescription")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapb"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/notes#nt",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Notes")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapb"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/contributors#con",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("List of Contributors")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapb"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/index#ind",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Index")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-218d4410","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/contents.vue
// module id = 72
// module chunks = 0